var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkCloseTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6 18.5L10.3 12.2C9.8 12.6 9.225 12.9167 8.575 13.15C7.925 13.3833 7.23333 13.5 6.5 13.5C4.68333 13.5 3.146 12.871 1.888 11.613C0.629333 10.3543 0 8.81667 0 7C0 5.18333 0.629333 3.64567 1.888 2.387C3.146 1.129 4.68333 0.5 6.5 0.5C8.31667 0.5 9.85433 1.129 11.113 2.387C12.371 3.64567 13 5.18333 13 7C13 7.73333 12.8833 8.425 12.65 9.075C12.4167 9.725 12.1 10.3 11.7 10.8L18 17.1L16.6 18.5ZM6.5 11.5C7.75 11.5 8.81267 11.0627 9.688 10.188C10.5627 9.31267 11 8.25 11 7C11 5.75 10.5627 4.68733 9.688 3.812C8.81267 2.93733 7.75 2.5 6.5 2.5C5.25 2.5 4.18733 2.93733 3.312 3.812C2.43733 4.68733 2 5.75 2 7C2 8.25 2.43733 9.31267 3.312 10.188C4.18733 11.0627 5.25 11.5 6.5 11.5ZM4 8V6H9V8H4Z",
    fill: "#343A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkCloseTable);
export default __webpack_public_path__ + "static/media/bookmark_close_table.c29dcff78c65008f6cfe8fc12088312f.svg";
export { ForwardRef as ReactComponent };